// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".QX2hNEF1H5kFWM_5Z7Y8 {\n    height: 72px;\n    border-bottom: 1px solid var(--colors_dark_500);\n}\n", "",{"version":3,"sources":["webpack://./src/components/TokenDetails/index.module.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,+CAA+C;AACnD","sourcesContent":[".token {\n    height: 72px;\n    border-bottom: 1px solid var(--colors_dark_500);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"token": "QX2hNEF1H5kFWM_5Z7Y8"
};
export default ___CSS_LOADER_EXPORT___;
